export default __webpack_public_path__ + "static/media/GLICEMIAICONA.990d2131.svg";